import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "nav" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "lds-ripple" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_6 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Navbar),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_view),
        _createVNode(_component_Footer)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["loading", {'--show': $setup.loading}])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("h4", {
          class: "load-text",
          textContent: _toDisplayString(_ctx.$t('loading'))
        }, null, 8, _hoisted_6)
      ])
    ], 2)
  ], 64))
}